import { useEffect } from "react";
import { setGuestUserKey } from "../../../Utils/UserFunctions";

const ScmMetaGuestKey = ({ attributes }) => {
  const { value, content } = attributes || {};

  useEffect(() => {
    const key = value || content;
    if (key?.trim()) {
      setGuestUserKey(key.trim());
    }
  }, [value, content]);

  return null;
};

export default ScmMetaGuestKey;
